// File: src/modules/jobs/JobStyles.js

import styled from 'styled-components';

export const Container = styled.div`
  padding: 20px;
  background-color: ${(props) => props.theme.colors.background};
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${(props) => props.theme.spacing(3)};
`;

export const Title = styled.h1`
  font-size: 24px;
  color: ${(props) => props.theme.colors.primaryText};
`;

export const Button = styled.button`
  padding: ${(props) => props.theme.spacing(1)} ${(props) => props.theme.spacing(3)};
  background-color: ${(props) => props.theme.colors.primary};
  color: white;
  border: none;
  border-radius: ${(props) => props.theme.borderRadius};
  cursor: pointer;
  &:hover {
    background-color: ${(props) => props.theme.colors.primaryHover};
  }
`;

export const CardWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${(props) => props.theme.spacing(2)};
  margin-bottom: ${(props) => props.theme.spacing(2)};
`;

export const Card = styled.div`
  flex: 1 1 calc(33.33% - ${(props) => props.theme.spacing(3)});
  padding: ${(props) => props.theme.spacing(4)};
  background-color: ${(props) => props.theme.colors.surface};
  border-radius: ${(props) => props.theme.borderRadius};
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  @media (max-width: 768px) {
    flex: 1 1 100%;
  }
`;

export const CardTitle = styled.h3`
  font-size: 18px;
  color: ${(props) => props.theme.colors.primaryText};
  margin-bottom: ${(props) => props.theme.spacing(0)};
  margin-left: 0px;
  padding: 0px;
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing(1)};
`;

export const Tab = styled.span`
`;

// Tabs Container for Navigation Tabs
export const Tabs = styled.div`
  display: flex;
  border-bottom: 2px solid #f69620;
  margin-bottom: 20px;
`;

// Individual Tab Styling (Fix: Change `Tab` to `TabButton` if needed)
export const TabButton = styled.button`
  padding: 10px 20px;
  background: none;
  border: none;
  cursor: pointer;
  color: ${({ active }) => (active ? '#f69620' : '#ffffff')};
  font-size: 16px;
  border-bottom: ${({ active }) => (active ? '2px solid #f69620' : 'none')};

  &:hover {
    color: #ff8c00;
  }
`;

// Table for Job List (Including TableBody)
export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background-color: #272727;
`;

// Table Header Row
export const TableHeader = styled.thead`
  background-color: #f69620;
  color: #ffffff;
`;

// Table Row Styling
export const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #333333;
  }
`;

// Table Body Styling (Add TableBody export)
export const TableBody = styled.tbody`
  background-color: #272727;
`;

// Table Data Styling
export const TableData = styled.td`
  padding: 12px 15px;
  border: 1px solid #444444;
  text-align: left;
`;

// Wrapper for Tabs in JobDetails (Fix: Add TabWrapper export)
export const TabWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 10px 0;
  border-bottom: 1px solid #444444;
  margin-bottom: 20px;
`;

// Calendar Wrapper for Displaying the Calendar
export const CalendarWrapper = styled.div`
  width: 50%;
  background-color: #272727;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  margin-bottom: 20px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

// Map Wrapper for Displaying the Map
export const MapWrapper = styled.div`
  width: 50%;
  background-color: #272727;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  margin-bottom: 20px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

// Flex Container for Responsive Design
export const FlexContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 20px;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;